import { forwardRef } from 'react';
import * as RadixPopover from '@radix-ui/react-popover';

type Props = Omit<RadixPopover.PopoverTriggerProps, 'asChild'>;

export const Trigger = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { children, ...rest } = props;

  return (
    <RadixPopover.Trigger ref={ref} asChild {...rest}>
      {children}
    </RadixPopover.Trigger>
  );
});
